import React, { Component } from 'react';
import { connect } from 'react-redux';
import ModalBody from './ModalBody';
import ModalControls from './ModalControls';
import ModalFooter from './ModalFooter';
import ModalHeader from './ModalHeader';
import ReduxModal from './ReduxModal';
import { closeModal, openModal } from '../../../redux/actions';
import { CONFIRM_MODAL } from '../../../redux/reducers/modal';
import type { SingleModalState } from '../../../types';

type Props = {
  confirmationDescription: string,
  onOpenModal: (modal: SingleModalState) => void,
  onCloseModal: (modal: SingleModalState) => void,
  onConfirm: () => void,
};

class ConfirmModal extends Component<Props> {
  static defaultProps = {
    confirmationDescription: 'Are you sure?',
  };

  modalId = { id: CONFIRM_MODAL } as any;

  handleConfirm = () => {
    const { onConfirm, onCloseModal } = this.props;
    onCloseModal(this.modalId);
    onConfirm();
  };

  render(): React.ReactNode {
    const {
      confirmationDescription, onOpenModal, onCloseModal,
    } = this.props;
    const { modalId } = this;

    return (
      <>
        <button
          className="btn btn-primary primary-color"
          type="button"
          onClick={() => onOpenModal(modalId)}
        >
          Fetch holidays from API
        </button>
        <ReduxModal id={CONFIRM_MODAL as any}>
          <ModalHeader title="Confirm action" onCloseClick={() => onCloseModal(modalId)} />
          <ModalBody>
            {confirmationDescription}
          </ModalBody>
          <ModalFooter>
            <ModalControls
              showEditButton={false}
              disableButtons={false}
              onCloseButtonClick={() => onCloseModal(modalId)}
              onSubmitButtonClick={this.handleConfirm}
              submitButtonText="Yes"
            />
          </ModalFooter>
        </ReduxModal>
      </>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  onOpenModal: (modal: SingleModalState) => dispatch(openModal(modal)),
  onCloseModal: (modal: SingleModalState) => dispatch(closeModal(modal)),
});

type ExternalProps = {
  onConfirm: () => void,
  confirmationDescription?: string,
};

const ConnectedConfirmModal = connect(null, mapDispatchToProps)(ConfirmModal) as unknown as React.ComponentType<ExternalProps>;

export default ConnectedConfirmModal;
